import { useMemo } from 'react';
import type { DebouncedFunc } from 'lodash';
import debounce from 'lodash/debounce';

export const useDebouncedAddressUpdate = (
  setAddressToGeocode: (value: string) => void,
): DebouncedFunc<(value: string) => void> => {
  return useMemo(
    () =>
      debounce((value: string) => {
        if (value && value.trim().length > 0) {
          setAddressToGeocode(value);
        } else {
          setAddressToGeocode('');
        }
      }, 500),
    [setAddressToGeocode],
  );
};

export default useDebouncedAddressUpdate;
